import * as types from './mutation-types'

const initialState = {
    regroupements: {
        editMode: false
    }
}

const state = { ...initialState }
const mutations = {
    [types.TOGGLE_REGROUPEMENTS_EDIT_MODE]({ regroupements }) {
        Vue.set(regroupements, 'editMode', !regroupements.editMode)
    }
}
const actions = {
    toggleRegroupementEditMode({ commit, dispatch }) {
        dispatch('resetCurrentRegroupement')
        commit(types.TOGGLE_REGROUPEMENTS_EDIT_MODE)
    }
}

const getters = {
    regroupementsEditMode: state => state.regroupements.editMode
}

export default { state, mutations, actions, getters }
